import { gsap, TweenMax, TweenLite, DrawSVGPlugin, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, TweenMax, TweenLite, DrawSVGPlugin);

// Trigger header on scroll
gsap.to('header .header', { 
  duration: 0.2,
  scrollTrigger: {
    start: 'top -50',
    end: 99999,
    toggleActions: 'play none none reverse',
    toggleClass: {className: 'scrolled', targets: 'header.wp-block-template-part'},
  },
});

// Stagger columns
gsap.defaults({ease: 'none'});
gsap.set('main.wp-block-group .entry-content .wp-block-group:not(:first-child, .teamContainer .wp-block-columns) .wp-block-columns:not(.is-style-indrukwekkend-overlap, .is-style-indrukwekkend-overlap-rechts) .wp-block-column', {opacity: 0, y: 100});
ScrollTrigger.batch('main.wp-block-group .entry-content .wp-block-group:not(:first-child, .teamContainer) .wp-block-columns:not(.is-style-indrukwekkend-overlap, .is-style-indrukwekkend-overlap-rechts) .wp-block-column', {
  start: 'top 80%',
  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, once: true}),
});
ScrollTrigger.addEventListener('refreshInit', () => gsap.set('main.wp-block-group .entry-content .wp-block-group:not(:first-child, .teamContainer) .wp-block-columns:not(.is-style-indrukwekkend-overlap, .is-style-indrukwekkend-overlap-rechts) .wp-block-column', {y: 0}));

// Search
var button = document.querySelector('div.search-icon');
var tween = TweenLite.from('header .wp-block-search', 0.3, {y:-100, opacity:0});
var icon = TweenMax.set(button, { css:{ className:'search-icon active' } });
tween.reverse();
icon.reverse();

if (typeof button !== 'undefined' && button !== null) {
  button.onclick = function() {
    tween.reversed(!tween.reversed());
    icon.reversed(!icon.reversed());
  }
}

export function upArrow() {
  if (!document.getElementById('back-to-top')) {return;}
  const backToTop =  document.getElementById('back-to-top');
  backToTop.addEventListener('click', (e)=>{
    e.preventDefault();
    gsap.to(window, { duration: 1, scrollTo: 0, ease: 'power2' });
  })
  let scrollpos = window.scrollY;
  window.addEventListener('scroll', function() {
    scrollpos = window.scrollY;
    if (scrollpos >= 200 ) { 
      backToTop.classList.add('show');
    }
    else { 
      backToTop.classList.remove('show');
    }
  })
}

// Media-text block
gsap.utils.toArray(['main.wp-block-group .entry-content .wp-block-group:not(:first-child) .is-style-indrukwekkend-overlap, main.wp-block-group .entry-content .wp-block-group:not(:first-child) .is-style-indrukwekkend-overlap-rechts']).forEach(function(elem) {
  let figure= elem.querySelector('.wp-block-column:first-child');
  let content = elem.querySelector('.wp-block-column:last-child');
  hide(figure);
  hide(content);
  ScrollTrigger.create({
    trigger: elem,
    once: true,
    start: 'top 80%',
    onEnter: function() { animateFrom(elem) }, 
    onEnterBack: function() { animateFrom(elem, -1) },
  });
});

// Animate functions
function animateFrom(elem) {
  var x = 0,
      y = 0;
  if(elem.classList.contains(['overlap-rechts'])) {
    x = 500;
    y = 0;
  } else {
    x = -500;
    y = 0;
  }
  let figure= elem.querySelector('.wp-block-column:first-child');
  gsap.fromTo(figure, {x: x, y: y, autoAlpha: 0}, {
    duration: 1.8, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
  let content = elem.querySelector('.wp-block-column:last-child');
  x = 500,
  y = 0;
  gsap.fromTo(content, {x: x, y: y, autoAlpha: 0}, {
    duration: 1.8, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
}
function hide(elem) {
  gsap.set(elem, {autoAlpha: 0})
}
